export default "__VITE_ASSET__BZOxfAZB__"